export default __webpack_public_path__ + "assets/icons/chevron-left.6bff46cf.svg";